/**
 * Tenant-specific asset exports.
 *
 * Both tenant folders use identical filenames — only the content differs.
 * Add new tenant-specific assets here following the same byTenant() pattern.
 * Shared assets that never differ between tenants stay in assets/images/.
 */
import { byTenant } from "../../utils/byTenant";

import jameoOnboarding from "../../assets/tenant/jameo/onboarding.jpg";
import attractionOnboarding from "../../assets/tenant/attraction/onboarding.jpg";

import jameoMarquee1 from "../../assets/tenant/jameo/marquee_img_1.jpg";
import jameoMarquee2 from "../../assets/tenant/jameo/marquee_img_2.jpg";
import jameoMarquee3 from "../../assets/tenant/jameo/marquee_img_3.jpg";
import jameoMarquee4 from "../../assets/tenant/jameo/marquee_img_4.jpg";
import jameoMarquee5 from "../../assets/tenant/jameo/marquee_img_5.jpg";
import jameoMarquee6 from "../../assets/tenant/jameo/marquee_img_6.jpg";
import jameoMarquee7 from "../../assets/tenant/jameo/marquee_img_7.jpg";
import attractionMarquee1 from "../../assets/tenant/attraction/marquee_img_1.jpg";
import attractionMarquee2 from "../../assets/tenant/attraction/marquee_img_2.jpg";
import attractionMarquee3 from "../../assets/tenant/attraction/marquee_img_3.jpg";
import attractionMarquee4 from "../../assets/tenant/attraction/marquee_img_4.jpg";
import attractionMarquee5 from "../../assets/tenant/attraction/marquee_img_5.jpg";
import attractionMarquee6 from "../../assets/tenant/attraction/marquee_img_6.jpg";
import attractionMarquee7 from "../../assets/tenant/attraction/marquee_img_7.jpg";
import attractionMarquee8 from "../../assets/tenant/attraction/marquee_img_8.jpg";
import attractionMarquee9 from "../../assets/tenant/attraction/marquee_img_9.jpg";

export const onboarding = byTenant(jameoOnboarding, attractionOnboarding);

export const marqueeImages = byTenant(
  [
    jameoMarquee1,
    jameoMarquee2,
    jameoMarquee3,
    jameoMarquee4,
    jameoMarquee5,
    jameoMarquee6,
    jameoMarquee7,
  ],
  [
    attractionMarquee1,
    attractionMarquee2,
    attractionMarquee3,
    attractionMarquee4,
    attractionMarquee5,
    attractionMarquee6,
    attractionMarquee7,
    attractionMarquee8,
    attractionMarquee9,
  ]
);
